import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { userService } from "services/userService";

const UserDatabaseContext = createContext();

export const UserDatabaseProvider = ({ children }) => {
  const pageSize = 10;

  const [sortBy, setSortBy] = useState("created_at_newest");
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fetchedUsers, setFetchedUsers] = useState([]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await userService.getAllUsers(pageSize, pageNumber, sortBy, searchQuery);
      setFetchedUsers(response.users);
      setNumberOfPages(response.totalPages);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [pageNumber, sortBy, searchQuery]);

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <UserDatabaseContext.Provider
      value={{
        pageSize,
        sortBy,
        setSortBy,
        searchQuery,
        setSearchQuery,
        pageNumber,
        setPageNumber,
        numberOfPages,
        setNumberOfPages,
        loading,
        error,
        fetchedUsers,
      }}
    >
      {children}
    </UserDatabaseContext.Provider>
  );
};

UserDatabaseProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useUserDatabase = () => useContext(UserDatabaseContext);
